import React from 'react'
import { Helmet } from 'react-helmet'
import Banner11 from '../components/banner11'
import './rules.css'

const RuleSection = ({ number, title, children }) => (
  <article className="rules-card">
    <div className="rules-number">{number}</div>
    <div>
      <h2 className="thq-heading-3">{title}</h2>
      <p className="thq-body-small">{children}</p>
    </div>
  </article>
)

const Rules = () => (
  <div className="rules-container1">
    <Helmet>
      <title>NuggetCraft SMP Rules</title>
      <meta name="description" content="The rules and guidelines for NuggetCraft SMP." />
      <meta property="og:title" content="NuggetCraft SMP Rules" />
      <link rel="canonical" href="https://kcserver.cc/rules" />
    </Helmet>

    <Banner11
      heading1="NuggetCraft SMP Rules"
      content1="These are the rules that members of NC SMP are expected to follow, regardless of the situation."
    />

    <main className="rules-main thq-section-padding">
      <div className="rules-max-width thq-section-max-width">
        <div className="rules-notice">
          <strong>Read before playing:</strong> Rules exist to keep the server fair, fun, and welcoming. Staff may act on behavior that clearly harms the community even when it is not listed word-for-word below.
        </div>

        <div className="rules-list">
          <RuleSection number="01" title="Respect other players">
            No harassment, bullying, hate speech, threats, targeted abuse, or intentionally disruptive behavior. Treat other players and staff with basic respect.
          </RuleSection>
          <RuleSection number="02" title="No cheating or exploits">
            Do not use hacked clients, unfair automation, x-ray or similar tools, duplication glitches, or exploits to gain an unfair advantage. Report serious bugs to staff instead of abusing them.
          </RuleSection>
          <RuleSection number="03" title="No griefing or stealing">
            Do not destroy, alter, or take another player's builds or belongings without permission. Respect protected areas and staff instructions.
          </RuleSection>
          <RuleSection number="04" title="Keep chat appropriate">
            Do not spam, flood chat, impersonate staff, advertise unrelated services, or deliberately create arguments. Keep usernames, signs, books, and other public content appropriate for the community.
          </RuleSection>
          <RuleSection number="05" title="No malicious activity">
            Do not attempt to crash, lag, DDoS, compromise, or otherwise disrupt the server or another player's account. Do not share or request passwords or other private credentials.
          </RuleSection>
          <RuleSection number="06" title="Staff decisions">
            Follow reasonable instructions from staff while an issue is being handled. If you disagree with a decision, appeal it calmly through the appropriate channel rather than escalating the situation in-game.
          </RuleSection>
          <RuleSection number="07" title="Report problems">
            Report rule violations, bugs, or security concerns to staff with enough information for them to investigate. Do not retaliate against players who make good-faith reports.
          </RuleSection>
        </div>

        <div className="rules-footer">
          Rules may be updated as the server grows. By playing on NuggetCraft SMP, you agree to follow the current rules and staff guidance.
        </div>

        <a className="thq-button-outline rules-home-link" href="/">← Back to Home</a>
      </div>
    </main>
  </div>
)

export default Rules
